export default __webpack_public_path__ + "334a1101a02e0791beb0bc938ca3a426.png";